'use client';
import { useState, useEffect } from 'react';
import { Project } from '@/utils/types';
import { useRouter } from 'next/navigation';
import { Pagination } from '@/components/pagination';
import { ProjectCard } from './project-card';
import { motion } from 'motion/react';

type Props = {
  posts: Array<Project>;
  showPagination?: boolean;
};

const POSTS_PER_PAGE = 10;

export const ProjectsGrid: React.FC<Props> = ({
  posts,
  showPagination = true,
}) => {
  const router = useRouter();

  const [currentPage, setCurrentPage] = useState(1);

  const totalPosts = posts.length;
  const totalPages = Math.ceil(totalPosts / POSTS_PER_PAGE);

  // Pagination logic
  const startIndex = (currentPage - 1) * POSTS_PER_PAGE;
  const currentPosts = posts.slice(startIndex, startIndex + POSTS_PER_PAGE);

  const prevPage = currentPage > 1 ? currentPage - 1 : null;
  const nextPage = currentPage < totalPages ? currentPage + 1 : null;

  // Sync the page number with the URL query parameter
  useEffect(() => {
    const pageFromQuery = new URLSearchParams(window.location.search).get(
      'page',
    );
    if (pageFromQuery) {
      setCurrentPage(Number(pageFromQuery));
    }
  }, []);

  // Function to handle page change and update URL
  const changePage = (page: number) => {
    // Update the URL with the new page without full page reload
    setCurrentPage(page);
    router.push(`?page=${page}`); // No scroll option here
  };

  return (
    <>
      <div className="grid grid-cols-4 gap-x-6 gap-y-4">
        {currentPosts.slice(0, 8).map((post: any) => {
          return <ProjectCard key={post.slug} project={post} />;
        })}
      </div>

      {/* {showPagination && (
        <Pagination
          page={currentPage}
          itemsPerPage={POSTS_PER_PAGE}
          totalItems={totalPosts}
          onClickPrev={() => {
            prevPage && changePage(prevPage);
          }}
          onClickNext={() => {
            nextPage && changePage(nextPage);
          }}
          onClickToPage={changePage}
          className="mt-16"
        />
      )} */}
    </>
  );
};

export default ProjectsGrid;
